import ImageRecord from './ImageRecord';
import Organization from './Organization';
import NavItem from './NavItem';
import Link from './Link';
import GenericPage from './GenericPage';
import ErrorPage from './ErrorPage';
import HomePage from './HomePage';
import CompanyPage from './CompanyPage';
import ProductPage from './ProductPage';
import TextPage from './TextPage';
import ChroniquePage from './ChroniquePage';
import ReferencePage from './ReferencePage';
import EmploiPage from './EmploiPage';
import NewOfferPage from './NewOfferPage';
import ContactPage from './ContactPage';
import ContactFormPage from './ContactFormPage';

export {
  ImageRecord,
  Organization,
  NavItem,
  Link,
  HomePage,
  CompanyPage,
  ProductPage,
  TextPage,
  GenericPage,
  ErrorPage,
  ChroniquePage,
  ReferencePage,
  EmploiPage,
  NewOfferPage,
  ContactPage,
  ContactFormPage,
};



// WEBPACK FOOTER //
// ./src/models/index.js